import { type Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ErrorDetail,
  ErrorMessage,
  type FileSelectionAction,
  type FileSelectionState,
  Upload,
  Widget as PortalWidget,
} from '@asset-metrix/portal-ui';
import clsx from 'clsx';

import { type ParseTemplateValidationError } from '../../api/portalGateway/parseDataIngestionTemplate';

import { portalWidgetContentStyle } from './dataIngestionPortalWidgetStyles';

import styles from './dataIngestionModal.module.scss';

export function UploadAndParseStep({
  fileState,
  dispatch,
  uploadStatus,
}: {
  fileState: FileSelectionState;
  dispatch: Dispatch<FileSelectionAction>;
  uploadStatus?: {
    state: 'pending' | 'success' | 'error';
    message?: string;
    errors?: ParseTemplateValidationError[];
  };
}) {
  const { t } = useTranslation();

  const renderExecutionLog = () => {
    if (uploadStatus?.state === 'success') {
      return t('app.dataIngestion.uploadAndParse.executionLogSuccess');
    }

    if (uploadStatus?.state === 'error') {
      if (uploadStatus.errors !== undefined && uploadStatus.errors.length > 0) {
        return <ErrorDetail items={uploadStatus.errors} />;
      }
      return (
        <ErrorMessage>
          {uploadStatus.message ??
            t('app.dataIngestion.uploadAndParse.executionLogErrorFallback')}
        </ErrorMessage>
      );
    }

    return t('app.dataIngestion.uploadAndParse.executionLogPlaceholder');
  };

  return (
    <div className={clsx(styles['stepContentColumns'])}>
      <PortalWidget
        contentStyle={portalWidgetContentStyle}
        classNames={{
          root: styles['modalWidget'],
          title: styles['modalWidgetTitle'],
        }}
        title={t('app.dataIngestion.uploadAndParse.templateInput')}
      >
        <Upload fileState={fileState} dispatch={dispatch} maxFiles={1} />
      </PortalWidget>
      <PortalWidget
        contentStyle={portalWidgetContentStyle}
        classNames={{
          root: styles['modalWidget'],
          title: styles['modalWidgetTitle'],
        }}
        title={t('app.dataIngestion.uploadAndParse.executionLog')}
      >
        {renderExecutionLog()}
      </PortalWidget>
    </div>
  );
}
